angular.module('bbl.services.simpleshare')

.directive('simpleVideoStream', ['$window', '$parse', function($window, $parse) {
  return {
    restrict: 'EA',
    template: '<span></span><video autoplay></video>',
    link:function(scope, element, atts) {
      var $el = $(element[0]), $vid = $el.find('video')[0],
        $span = $el.find('span'),
        stream = $parse(atts.stream)(scope),
        caller = $parse(atts.caller)(scope);

      if(caller) {
        $span.text(caller.username);
      }

      var URL = $window.URL;
      // attach the stream
      if ($vid.srcObject !== undefined) {
        $vid.srcObject = stream;
      } else if ($vid.mozSrcObject !== undefined) {
        $vid.mozSrcObject = stream;
      } else if (URL && URL.createObjectURL) {
        $vid.src = URL.createObjectURL(stream);
      }

      $vid.muted = true;
      $vid.play().catch(function() {
        // $span.text('Tap to play the video stream.');
        // $span.css({
        //   'position': 'absolute',
        //   'top': '50%',
        //   'left': '50%',
        //   'color': '#fff',
        //   'text-shadow': '0 0 3px black',
        //   'font-size': '26px',
        //   'transform': 'translate(-50%, -50%)',
        // });
        document.addEventListener('click', function autoplay() {
          // $span.text('');
          // $span[0].style = '';
          $vid.play();
          document.removeEventListener('click', autoplay);
        });
      });

      scope.$eval(atts.onReady, {$event: {
        requestFullScreen: ($vid.requestFullscreen || $vid.webkitRequestFullScreen || $vid.mozRequestFullScreen || $vid.msRequestFullscreen || angular.noop).bind($vid),
      }});
    }
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/simpleshare/directives/video-stream.js
 ** module id = 223
 ** module chunks = 0
 **/